import api from './api';

class AuthService {
    /**
     * Request OTP for mobile number
     * @param {string} mobile - Mobile number
     * @returns {Promise} API response
     */
    async requestOTP(mobile) {
        try {
            const response = await api.post('/auth/vendor/login', {
                mobile_number: mobile
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Login with mobile number and OTP
     * @param {string} mobile - Mobile number
     * @param {string} otp - One-time password
     * @returns {Promise} API response with user data and token
     */
    async login(mobile, otp) {
        try {
            const response = await api.post('/auth/vendor/verify-otp', {
                mobile_number: mobile,
                otp_code: otp
            });
            
            // Store token in localStorage
            if (response.data.access_token) {
                localStorage.setItem('vendor_token', response.data.access_token);
            }
            
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Register new vendor
     * @param {Object} userData - Vendor registration data
     * @returns {Promise} API response
     */
    async register(userData) {
        try {
            const response = await api.post('/vendors/', userData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get current user information
     * @returns {Promise} Current user data
     */
    async getCurrentUser() {
        try {
            const response = await api.get('/auth/me');
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Logout user
     * @returns {Promise} API response
     */
    async logout() {
        try {
            await api.post('/auth/logout');
            localStorage.removeItem('vendor_token');
            return { success: true };
        } catch (error) {
            // Even if API call fails, remove token locally
            localStorage.removeItem('vendor_token');
            throw error;
        }
    }

    /**
     * Refresh authentication token
     * @returns {Promise} API response with new token
     */
    async refreshToken() {
        try {
            const response = await api.post('/auth/refresh');
            if (response.data.access_token) {
                localStorage.setItem('vendor_token', response.data.access_token);
            }
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Update vendor profile
     * @param {Object} profileData - Profile update data
     * @returns {Promise} API response
     */
    async updateProfile(profileData) {
        try {
            const response = await api.put('/vendors/profile', profileData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Check if user is authenticated
     * @returns {boolean} Authentication status
     */
    isAuthenticated() {
        const token = localStorage.getItem('vendor_token');
        return !!token;
    }

    /**
     * Get stored authentication token
     * @returns {string|null} Authentication token
     */
    getToken() {
        return localStorage.getItem('vendor_token');
    }
}

export const authService = new AuthService(); 